import script from "./CreditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreditPage.vue?vue&type=script&setup=true&lang=ts"

import "./CreditPage.vue?vue&type=style&index=0&id=5984477a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5984477a"]])

export default __exports__